import * as z from "zod";

export const createConsolidationViewFolder = {
  name: "createConsolidationViewFolder" as const,
  input: z.object({ name: z.string() }),
  output: z.object({ folderId: z.string() }),
};
